import { b } from "@/b";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { FragmentData } from "@gqlb/core";
import React from "react";

export const TagsFilter_Fragment = b.fragment("TagsFilter", "Menu", (b) => [
  //
  b.tags((b) => [
    //
    b.id(),
    b.name(),
  ]),
]);

export const TagsFilter: React.FC<{
  data: FragmentData<typeof TagsFilter_Fragment>;
  selectedTags: string[];
  onClick: (tag: string) => void;
  onClear: () => void;
}> = ({ data, onClick, selectedTags: selected, onClear }) => {
  return (
    <Box>
      <Box pos="sticky" top="32">
        <Text
          fontSize={{
            base: "xl",
            lg: "3xl",
          }}
        >
          Category
        </Text>
        <Box
          fontSize={{
            base: "sm",
            lg: "md",
          }}
        >
          {data.tags.map((t) => {
            return (
              <Flex
                key={t.id}
                onClick={() => {
                  onClick(t.id);
                }}
                cursor="pointer"
                flexDir="row"
                alignItems="center"
              >
                <Box
                  w="4"
                  h="4"
                  backgroundColor={
                    selected.includes(t.id) ? "#8DEBCF" : "#EFEFEF"
                  }
                  mr="2"
                  rounded="sm"
                />
                <Text maxW="56">{t.name}</Text>
              </Flex>
            );
          })}
          {selected.length !== 0 ? (
            <Button
              onClick={() => void onClear()}
              variant="link"
              ml="0"
              pl="0"
              color="#909090"
            >
              Clear
            </Button>
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};
